import { render, staticRenderFns } from "./FormUpdated.vue?vue&type=template&id=227ec732&scoped=true"
import script from "./FormUpdated.vue?vue&type=script&lang=js"
export * from "./FormUpdated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227ec732",
  null
  
)

export default component.exports